module.exports = __webpack_public_path__ + "img/influence.e769e16a.webp";